import { normalizeTitle } from './sku.js';
/**
 * Category -> keywords, ordered most specific first within each entry.
 *
 * Multi-word keywords are checked before single words so "coffee table" wins
 * over "table", and "bunk bed" over "bed". Keep the specific ones first.
 */
const CATEGORY_KEYWORDS = [
    ['Beds', ['bunk bed', 'canopy bed', 'platform bed', 'daybed', 'headboard', 'footboard', 'bed frame', 'bed']],
    ['Tables', ['coffee table', 'end table', 'side table', 'dining table', 'console table', 'sofa table',
            'night stand', 'nightstand', 'bedside table', 'pub table', 'card table', 'table']],
    ['Seating', ['rocking chair', 'dining chair', 'arm chair', 'armchair', 'accent chair', 'bar stool',
            'barstool', 'counter stool', 'stool', 'bench', 'settee', 'loveseat', 'sofa', 'couch',
            'glider', 'recliner', 'chair']],
    ['Storage', ['chest of drawers', 'dresser', 'armoire', 'wardrobe', 'blanket chest', 'hope chest',
            'toy box', 'chest', 'cabinet', 'cupboard', 'hutch', 'sideboard', 'buffet', 'credenza',
            'bookcase', 'bookshelf', 'shelving', 'shelf', 'pantry']],
    ['Desks', ['writing desk', 'computer desk', 'roll top desk', 'secretary desk', 'desk']],
    ['Outdoor', ['porch swing', 'picnic table', 'adirondack', 'patio', 'porch', 'garden', 'outdoor']],
    ['Kitchen & Dining', ['kitchen island', 'bakers rack', 'baker rack', 'wine rack', 'dining set', 'table set']],
    ['Decor', ['picture frame', 'wall art', 'mirror', 'clock', 'lamp', 'candle', 'sign', 'wreath', 'decor']],
    ['Bedding & Textiles', ['bedding', 'bed skirt', 'duvet', 'quilt', 'comforter', 'coverlet', 'pillow', 'sham',
            'sheet set', 'throw', 'blanket', 'curtain', 'rug', 'runner', 'placemat', 'table cloth',
            'tablecloth', 'napkin', 'towel']],
    ['Accessories', ['coat rack', 'hall tree', 'towel rack', 'shoe rack', 'magazine rack', 'rack', 'hook',
            'basket', 'tray', 'organizer']],
];
/**
 * Infers a furniture type from a title. Returns null when nothing matches,
 * which is honest — a wrong guess is worse than an empty cell.
 */
export function inferCategory(title) {
    const haystack = ` ${normalizeTitle(title)} `;
    let best = null;
    for (const [category, keywords] of CATEGORY_KEYWORDS) {
        for (const keyword of keywords) {
            // Pad both sides so "bed" does not match "bedding" or "embedded".
            if (!haystack.includes(` ${keyword} `) && !haystack.includes(` ${keyword}s `)) {
                continue;
            }
            // Specificity drives confidence: a two-word match is far stronger
            // evidence than a bare "table".
            const words = keyword.split(' ').length;
            const confidence = Math.min(95, 45 + words * 20 + Math.min(keyword.length, 15));
            if (best === null || confidence > best.confidence) {
                best = { category, confidence, matchedOn: keyword };
            }
            // First (most specific) hit within a category is enough; move on.
            break;
        }
    }
    return best;
}
/** Every category this inferrer can produce — useful for filter dropdowns. */
export const INFERRABLE_CATEGORIES = CATEGORY_KEYWORDS.map(([name]) => name);
//# sourceMappingURL=category.js.map